module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/theme-2-3efda0f7765d1bcefb3cd9ee62482739.webp";